export default __webpack_public_path__ + "static/searchcases-0dd439de2de0a982b10e38d2d649809b.png";